import { Form } from 'antd';
import { useContext } from 'react';

import { PictureList } from 'app/components/commons/ImageUploader/PictureList/PictureList';
import { PictureGallery } from 'app/components/commons/Package/Pictures/PictureGallery';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import type { Picture } from 'app/typings';
import type { PictureView } from 'app/typings/core/common/pictureView/pictureView';
import { ExperienceType } from 'app/typings/experiences';

import {
  DEFAULT_KIND,
  pictureToPictureView,
  pictureViewToPicture,
} from './utils';

const DEFAULT_PICTURES_CATEGORIES = [
  { name: 'Official', type: 'official' },
  { name: 'Sourcing', type: DEFAULT_KIND },
];

export const Photos = () => {
  const { isEditMode } = useContext(ViewEditModeContext);

  const form = Form.useFormInstance();
  const picturesValues = Form.useWatch<PictureView[]>(
    'experiencePictures',
    form
  );
  const hotelId = Form.useWatch('hotelId', form);
  const experienceType = Form.useWatch('experienceType', form);

  const isOriginal = experienceType === ExperienceType.STAYCATION;

  return (
    <Form.Item
      name="experiencePictures"
      valuePropName="value"
      getValueProps={(value: PictureView[]) => ({
        value: value?.map(pictureViewToPicture),
      })}
      getValueFromEvent={(pictures: Picture[]) =>
        pictures?.map(pictureToPictureView)
      }
    >
      {isEditMode ? (
        <PictureGallery
          sectionTitle="Add photos"
          hotelId={!isOriginal ? hotelId : undefined}
          picturesCategories={!isOriginal ? DEFAULT_PICTURES_CATEGORIES : []}
          kind={DEFAULT_KIND}
          previewable
          draggable
          editable
          removable
        />
      ) : picturesValues && picturesValues.length > 0 ? (
        <PictureList
          pictures={picturesValues.map(pictureViewToPicture)}
          uploadingItems={{}}
          previewable
        />
      ) : (
        <span className="view-data">ø empty</span>
      )}
    </Form.Item>
  );
};
